<template>
  <h1>Support</h1>
</template>

<script>
// @ is an alias to /src

export default {
  name: "Support",
};
</script>
